import { render, staticRenderFns } from "./ItemLocaleEditor.vue?vue&type=template&id=7bd76d90&scoped=true"
import script from "./ItemLocaleEditor.vue?vue&type=script&lang=ts"
export * from "./ItemLocaleEditor.vue?vue&type=script&lang=ts"
import style0 from "./ItemLocaleEditor.vue?vue&type=style&index=0&id=7bd76d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd76d90",
  null
  
)

export default component.exports